class ConfiguratorModal extends (window.ConfiguratorBase || HTMLElement) {
  getSource() { return 'modal'; }

  cacheAdditionalRefs() {
    this._submitBtn = this.querySelector('[data-ref="submitBtn"]');
    this._closeBtn = this.querySelector('[data-ref="closeBtn"]');
    this._backdrop = this.querySelector('[data-ref="backdrop"]');

    // Bind open/close here so they work even if configurator-data is missing.
    this._closeBtn?.addEventListener('click', () => this.#close());
    this._backdrop?.addEventListener('click', () => this.#close());
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.hasAttribute('hidden')) this.#close();
    });
    document.addEventListener('click', (e) => {
      if (e.target.closest('.configurator-modal__trigger-btn')) this.#open();
    });

    this.#checkUrlParam();
  }

  bindAdditionalEvents() {
    this._submitBtn?.addEventListener('click', () => this.#handleSave());
  }

  onSelectionComplete(_selection, _urls) {
    this._submitBtn?.removeAttribute('disabled');
  }

  onReset() {
    this._submitBtn?.setAttribute('disabled', '');
  }

  async onRestored(_saved, _urls) {
    this._submitBtn?.removeAttribute('disabled');
  }

  async #handleSave() {
    const selection = {
      make: this._makeSelect.value,
      model: this._modelSelect.value,
      year: this._yearSelect.value,
      bed: this._bedSelect.value,
      inbed: this._inbedSelect.value || '',
    };
    const key = `${selection.make}|${selection.model}|${selection.year}|${selection.bed}|${selection.inbed}`;
    let urlMap = await this._getUrlMap();
    if (!Object.keys(urlMap).length) urlMap = await this._getUrlMap();
    const urls = urlMap[key] || {};
    if (!Object.keys(urls).length) {
      console.warn('[configurator] modal key miss', { key, mapSize: Object.keys(urlMap).length });
    }
    this._saveTruck(selection, urls);
    document.dispatchEvent(new CustomEvent('configurator:update', { detail: { selection, urls } }));
    this.#close();
  }

  #open() {
    this.removeAttribute('hidden');
  }

  #close() {
    this.setAttribute('hidden', '');
  }

  #checkUrlParam() {
    if (new URLSearchParams(window.location.search).get('modal') === 'configurator') {
      this.#open();
    }
  }
}

if (!customElements.get('configurator-modal-component')) {
  customElements.define('configurator-modal-component', ConfiguratorModal);
}
